export interface Register {
  userName: string;
}

export type FormValues = {
  userName: string;
};

export interface ConfirmRegisterForm {
  userId: string;
  firstName: string;
  lastName: string;
  password: string;
  confirmPassword: string;
  token: string;
  name: string;
  customIndustryName: string;
  countryId: number;
  customerType: number;
  phoneNumber?: string;
  department?: string;
}

export interface ConfirmInviteRequestForm {
  userId: string;
  firstName: string;
  lastName: string;
  password: string;
  confirmPassword: string;
  token: string;
  name?: string;
  userName?: string;
}

export interface Login {
  userName: string;
  password: string;
}

export interface PinLogin {
  pinCode: string;
}

export interface LoginResult {
  tokenType: string;
  accessToken: string;
}

export interface ForgotPassword {
  userName: string;
}

export interface ResetPasswordModel {
  userName: string;
  token: string;
  newPassword: string;
}

export type ResetPasswordFormValues = {
  userName: string;
  token: string;
  newPassword?: string;
  confirmPassword?: string;
};

export interface User {
  id: string | undefined;
  firstName: string;
  lastName: string;
  role: string;
  phoneNumber?: string;
  companyType?: number;
}

export interface AccountState {
  user?: User;
  accessToken?: string;
}

export class Roles {
  static readonly SYSTEM_ADMINISTRATOR = "SystemAdministrator";
  static readonly ADMIN = "Admin";
  static readonly MANAGER = "Manager";
  static readonly WORKER = "Worker";
  static readonly VIEWER = "Viewer";
  static readonly ALL_COMPANY_ROLES = [Roles.ADMIN, Roles.MANAGER, Roles.WORKER, Roles.VIEWER];
  /** Roles that have web app access. Viewer is QR kiosk only — no web app. */
  static readonly WEB_APP_ROLES = [Roles.ADMIN, Roles.MANAGER, Roles.WORKER];
}

export const EMAIL_LOGIN_TAB_INDEX = 0;
export const PIN_LOGIN_TAB_INDEX = 1;